module.exports = __webpack_public_path__ + "img/bintan-logo.03ae3c7b.png";